
//定制弹窗配置类
const DialogConfig = {
  target: null,
  constructor() { },
  baseObj: {
    titleAlign: 'left',
    data: {},
    keepAlive: true,
    footerHide: true,
    maskClosable: false,
  },
  customConfig:{
    saleConfig: {
      title: '新增售后申请单',
      width: 1200,
      name: 'AFTER_SALE_APPLY_ORDER',
      url: require('@/views/modal/orderCenter/AFTER_SALE_APPLY_ORDER.vue').default,
      excludeString: 'AFTER_SALE_APPLY_ORDER',
    },
    chooseOrder: {
      title: '选择订单',
      width: 1000,
      url: require('@/views/pages/orderCenter/scanIn2/chooseOrder.vue').default,
      name: 'chooseOrder',
      excludeString: 'chooseOrder',
    },
    fillPriceDifference: {
      title: '补差价',
      width: 400,
      url: require('@/views/modal/orderCenter/fillPriceDifference.vue').default,
      name: 'fillPriceDifference',
      excludeString: 'fillPriceDifference',
    },
    ReciprocalExchange: {
      width: '800',
      name: 'ReciprocalExchange',
      url: require('@/views/modal/orderCenter/ReciprocalExchange.vue').default,
      excludeString: 'ReciprocalExchange',
      title: '对等换货'
    },
    SpecifyExpiryDate: {
      width: '850',
      name: 'SpecifyExpiryDate',
      url: require('@/views/pages/orderCenter/orderManager/SpecifyExpiryDate.vue').default,
      excludeString: 'SpecifyExpiryDate',
      title: '手动指定效期'
    },
    OC_ORDER_SEND_TIME: {
      title: '修改预计发货时间',
      width: 400,
      // url: 'modal/orderCenter/modifyPreDate',
      url: require('@/views/modal/orderCenter/modifyPreDate.vue').default,
      name: 'modifyPreDate',
      excludeString: 'modifyPreDate',
    },
    ModifyRemarks: {
      title: $it('mT.ap'), // 修改单据备注
      width: 650,
      // url: 'modal/orderCenter/returngood/rturngoodModifyRemarks',
      url: require('@/views/modal/orderCenter/returngood/rturngoodModifyRemarks.vue').default,
      name: 'rturngoodModifyRemarks',
      excludeString: 'rturngoodModifyRemarks',
    },
    // 零售发货单详情
    address: {
      title: $it('mT.modify_shipping_address'), // 修改收货地址
      width: 1000,
      // url: 'modal/orderCenter/resolveAddress',
      url: require('@/views/modal/orderCenter/resolveAddress.vue').default,
      name: 'addressDialog',
      excludeString: 'addressDialog',
    },
    blacklist: {
      title: $it('mT.blacklist'), // 加入黑名单
      width: 400,
      // url: 'order/joinBlackList',
      url: require('@/views/modal/orderCenter/resolveAddress.vue').default,
      name: 'blackListDialog',
      excludeString: 'blackListDialog',
    },
    addGift: {
      title: $it('btn.addGift'), // 添加赠品
      width: 1000,
      // url: 'modal/orderCenter/addGiftItem',
      url: require('@/views/modal/orderCenter/addGiftItem.vue').default,
      name: 'addGiftDialog',
      excludeString: 'addGiftDialog',
    },
    changeSku: {
      title: $it('btn.replaceGoods'), // 替换商品
      width: 800,
      // url: 'modal/orderCenter/replaceGoodsDetail',
      url: require('@/views/modal/orderCenter/replaceGoodsDetail.vue').default,
      name: 'changeSkuDialog',
      excludeString: 'changeSkuDialog',
    },
    // modifyRemark: {
    //   title: $it('btn.modifyRemarks'), // 修改备注
    //   width: 480,
    //   // url: 'modal/orderCenter/changeRemark',
    //   url: require('@/views/modal/orderCenter/changeRemark.vue').default,
    //   name: 'modifyRemarkDialog',
    //   excludeString: 'modifyRemarkDialog',
    // },
    changeRemarkConfig: {
      title: $it('btn.modify_sellerNotes'), // 修改卖家备注
      width: '480',
      name: 'changeRemark',
      // url: 'modal/orderCenter/changeRemark',
      url: require('@/views/modal/orderCenter/changeRemark.vue').default,
      excludeString: 'changeRemark',
    },
    modifyLogisticsConfig: {
      title: $it('btn.batchModify_logistics'), // 批量修改物流
      width: '400',
      name: 'modifyLogistics',
      // url: 'modal/orderCenter/modifyLogistics',
      url: require('@/views/modal/orderCenter/modifyLogistics.vue').default,
      excludeString: 'modifyLogistics',
    },
    modifyReturnLogistics: {
      title: '修改退回物流公司', // 批量修改物流
      width: '400',
      name: 'modifyReturnLogistics',
      url: require('@/views/modal/orderCenter/modifyReturnLogistics.vue').default,
      excludeString: 'modifyReturnLogistics',
    },
    makeOutInvoiceConfig: {
      title: $it('btn.recordInvoice'), // 记录发票
      width: '600',
      name: 'makeOutInvoice',
      // url: 'modal/orderCenter/makeOutInvoice',
      url: require('@/views/modal/financeCenter/creatInvoice.vue').default,
      excludeString: 'makeOutInvoice',
    },
    addGiftsConfig: {
      title: $it('btn.addGift'), // 添加赠品
      width: '1100',
      name: 'addGifts',
      // url: 'modal/orderCenter/addGifts',
      url: require('@/views/modal/orderCenter/addGifts.vue').default,
      excludeString: 'addGifts',
    },
    // 弹框配置 拖拽排序
    dropSortConfig: {
      title: $it('btn.sortForm'), // 排序表单
      width: '300',
      name: 'setFormDrag',
      // url: 'modal/orderCenter/setFormDrag',
      url: require('@/views/modal/orderCenter/setFormDrag.vue').default,
      excludeString: 'setFormDrag',
    },
    goodsDetailConfig: {
      title: $it('btn.order_detailed'), // 订单明细
      width: '900',
      name: 'goodsDetail',
      // url: 'modal/orderCenter/goodsDetail',
      url: require('@/views/modal/orderCenter/goodsDetail.vue').default,
      excludeString: 'goodsDetail',
    },
    changeWarehouseConfig: {
      title: $it('btn.batchModify_warehouse'), // 批量修改仓库
      width: '400',
      name: 'changeWarehouse',
      // url: 'modal/orderCenter/changeWarehouse',
      url: require('@/views/modal/orderCenter/changeWarehouse.vue').default,
      excludeString: 'changeWarehouse',
    },
    depositPresaleConfig: {
      title: $it('btn.preSaleAdvanceDeliveryMarking'), // 定金预售提前发货打标
      width: '800',
      name: 'manualMarking',
      // url: 'modal/orderCenter/manualMarking',
      url: require('@/views/modal/orderCenter/manualMarking.vue').default,
      excludeString: 'manualMarking',
    },
    replaceConfig: {
      title: $it('btn.batch_replaceGoods'), // 批量替换商品
      width: '1000',
      name: 'replaceTheGoods',
      // url: 'modal/orderCenter/changeProduct',
      url: require('@/views/modal/orderCenter/changeProduct.vue').default,
      excludeString: 'replaceTheGoods',
    },
    pushProduceConfig: {
      title: $it('btn.batch_addGift'), // 批量添加赠品
      width: '900',
      name: 'pushProduce',
      // url: 'modal/orderCenter/pushProduce',
      url: require('@/views/modal/orderCenter/pushProduce.vue').default,
      excludeString: 'pushProduce',
    },
    itemDeleteConfig: {
      title: $it('btn.batch_deleteGift'), // 批量删除赠品
      width: '800',
      name: 'itemDelete',
      // url: 'modal/orderCenter/itemDelete',
      url: require('@/views/modal/orderCenter/itemDelete.vue').default,
      excludeString: 'itemDelete',
    },
    specifyGoodsAssignConfig: {
      title: $it('btn.appointGoods_splitOrder'), // 指定商品拆单
      width: '700',
      name: 'specifyGoodsAssign',
      url: require('@/views/modal/orderCenter/specifyGoodsAssign.vue').default,
      excludeString: 'specifyGoodsAssign',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    //弹框配置 零售发货单详情界面替换商品弹框
    replaceGoodsDetailConfig: {
      title: $it('btn.replaceGoods'), // 替换商品
      width: '900',
      name: 'replaceGoodsDetail',
      // url: 'pages/orderCenter/orderManager/replaceGoodsDetail',
      url: require('@/views/modal/orderCenter/replaceGoodsDetail.vue').default,
      excludeString: 'replaceGoodsDetail',
    },
    updateEstimateConTime: {
      title: '修改预计发货时间', // Hold单
      width: '400',
      name: 'updateEstimateConTime',
      url: require('@/views/modal/orderCenter/updateEstimateConTime.vue').default,
      excludeString: 'updateEstimateConTime',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    // 周期购预计发货时间修改
    cycleUpdateEstimateConTime: {
      title: '修改周期购预计发货时间',
      width: '400',
      name: 'cycleUpdateEstimateConTime',
      url: require('@/views/modal/orderCenter/cycleUpdateEstimateConTime.vue').default,
      excludeString: 'cycleUpdateEstimateConTime',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    warehouseLogistics: {
      title: '寻仓寻物流',
      width: '1000',
      name: 'warehouseLogistics',
      url: require('@/views/modal/orderCenter/warehouseLogistics/warehouseLogistics.vue').default,
      excludeString: 'warehouseLogistics',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    // logicalOccupation: {
    //   title: '逻辑占用明细查询',
    //   width: '1000',
    //   name: 'logicalOccupation',
    //   url: require('@/views/modal/orderCenter/warehouseLogistics/logicalOccupation.vue').default,
    //   excludeString: 'logicalOccupation',
    //   componentData: {},
    //   quit: function () {
    //     this.closeConfirm()
    //   },
    // },
    // logicalBinLotInventory: {
    //   title: '逻辑仓批次库存查询',
    //   width: '1000',
    //   name: 'logicalBinLotInventory',
    //   url: require('@/views/modal/orderCenter/warehouseLogistics/logicalBinLotInventory.vue').default,
    //   excludeString: 'logicalBinLotInventory',
    //   componentData: {},
    //   quit: function () {
    //     this.closeConfirm()
    //   },
    // },
    holdOrderConfig: {
      title: $it('btn.holdOrder'), // Hold单
      width: '500',
      name: 'holdOrderDialog',
      // url: 'modal/orderCenter/holdOrderDialog',
      url: require('@/views/modal/orderCenter/holdOrderDialog.vue').default,
      excludeString: 'holdOrderDialog',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    batchDetentionConfig: {
      title: '卡单', // 卡单
      width: '500',
      name: 'batchDetentionDialog',
      url: require('@/views/modal/orderCenter/batchDetentionDialog.vue').default,
      excludeString: 'batchDetentionDialog',
      componentData: {},
      quit: function () {
        this.closeConfirm()
      },
    },
    scheduleFormConfig: {
      title: $it('pL.ac'), // 入库单、拣货单
      width: '800',
      name: 'scheduleFormDialog',
      // url: 'modal/strategyPlatform/scheduleFormDialog',
      url: require('@/views/modal/strategyPlatform/scheduleFormDialog.vue').default,
      excludeString: 'scheduleFormDialog',
    },
    copyPermissionConfig: {
      title: '复制权限', // 复制权限
      width: 400,
      name: 'copyPermission',
      // url: 'modal/systemConfig/copyPermission',
      url: require('@/views/modal/systemConfig/copyPermission.vue').default,
      excludeString: 'copyPermission',
    },
    // 弹窗配置 会员加急发货
    vipSpeedDispatchConfig: {
      title: $it('mT.ao'), // 会员加急发货打标
      width: 400,
      name: 'manualMarking',
      // url: 'modal/orderCenter/manualMarking',
      url: require('@/views/modal/orderCenter/manualMarking.vue').default,
      excludeString: 'manualMarking'
    },
    changeInternalRemarksConfig: {
      title: $it('fL.g3'), // 修改内部备注
      width: '440',
      name: 'changeInternalRemarks', // 组件名称
      url: require('@/views/modal/orderCenter/changeInternalRemarks').default,
      excludeString: 'changeInternalRemarks', // 将name传进去，确认不缓存
    },
    changeDetailRemarkConfig: {
      title: $it('btn.modifyRemarks'), // 修改备注
      width: '440',
      name: 'changeDetailRemarks', // 组件名称
      url: require('@/views/modal/orderCenter/changeRemark2').default,
      excludeString: 'changeDetailRemarks', // 将name传进去，确认不缓存
    },
    promotionGiftSetConfig: {
      title: '批量设置', // 批量设置
      width: '440',
      name: 'batchGiftSet',
      url: require('@/views/modal/promotionCenter/batchGiftSet.vue').default,
      excludeString: 'batchGiftSet',
    },
  },
  config() {
    return (DialogConfig.customConfig = Object.fromEntries(
      Object.entries(DialogConfig.customConfig).map(([key, value]) => {
        // (如果目标对象与源对象有同名属性，或多个) ==> 源对象有同名属性，则后面的属性会覆盖前面的属性
        // return [key, Object.assign(this.baseObj, value)];
        return [
          key,
          Object.fromEntries(
            Object.entries(DialogConfig.baseObj).concat(Object.entries(value))
          ),
        ]
      })
    ))
  },
}

export default DialogConfig
